// extracted by mini-css-extract-plugin
export default {"inputGroup":"CompanyForm_inputGroup__F3JxT","inputDate":"CompanyForm_inputDate__uOovs"};